<template>
<div>
    <b-modal id="modal-edit" ref="my-modal-edit" title="Form Edit Product Promo" size="xl" centered no-close-on-esc no-close-on-backdrop @ok="handleOk" @hidden="$parent.handleCancel">
        <form ref="formAdd" @submit.prevent="handleSubmit">
            <div class="form-row">
                <!-- <div class="form-group col-md-6 col-lg-6">
                    <label class="text text-info">Select Product</label>
                    <v-select label="name" :filterable="false" :options="products" v-model="formInput.id_product" :reduce="product => product.id" @search="onSearchProduct">
                        <template slot="no-options"> type to search product... </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                [{{ option.part_number}}] {{ option.name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                </div> -->
                <div class="form-group col-md-3 col-lg-3">
                    <label class="text text-info">Start</label>
                    <b-form-datepicker no-flip :date-format-options="{
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                        }" locale="id" v-model="formInput.start_date">
                    </b-form-datepicker>
                </div>
                <div class="form-group col-md-3 col-lg-3">
                    <label class="text text-info">End</label>
                    <b-form-datepicker no-flip :date-format-options="{
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                        }" locale="id" v-model="formInput.end_date" :min="formInput.start_date">
                    </b-form-datepicker>
                </div>
                <div class="form-group col-md-6 col-lg-4">
                    <label class="text text-info">Price</label>
                    <currency-input type="text" :valueAsInteger="true" :precision="0" :currency="null" locale="id" :allowNegative="false" :distractionFree="false" class="form-control" required v-model="formInput.price" />
                    <!-- <label class="text-danger error">{{ validation.firstError('formInput.max_discount') }}</label> -->
                </div>
                <div class="form-group col-md-6 col-lg-4">
                    <label class="text text-info">Discount (%)</label>
                    <currency-input type="text" :valueAsInteger="true" :precision="0" :currency="null" locale="id" :allowNegative="false" :distractionFree="false" class="form-control" required v-model="formInput.discount" />
                    <!-- <label class="text-danger error">{{ validation.firstError('formInput.discount_type') }}</label> -->
                </div>
                <div class="form-group col-md-6 col-lg-4">
                    <label class="text text-info">Description (Optional)</label>
                    <input type="text" class="form-control" placeholder="Enter the name" required v-model="formInput.description" />
                    <!-- <label class="text-danger error">{{ validation.firstError('formInput.purchase_currency') }}</label> -->
                </div>
            </div>
        </form>
    </b-modal>
</div>
</template>

<script>
import axios from "axios";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Compressor from 'compressorjs';

export default {
    name: "EditPromo",
    props: {
        propsRow: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formInput: {},
        };
    },
    watch: {
        propsRow: {
            immediate: true,
            handler() {
                this.formInput = Object.assign({}, this.propsRow);
            },
        },
    },
    methods: {
        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },

        async handleSubmit() {
            try {
                await this.$store.dispatch("setLoading", true);
                let resp = await axios.post(
                    "dental-erp-service/store/mobile/product_promo/update",
                    this.formInput, {
                        headers: {
                            Authorization: localStorage.getItem("token") || "",
                        },
                    }
                );

                if (resp.data.error === false) {
                    await this.$bvModal.hide('modal-edit');
                    this.$swal.fire("Success", resp.data.message, "success");
                    this.$parent.getData();
                }
            } catch (error) {
                if (error.response != undefined) {
                    if (error.response.data != undefined) {
                        if (error.response.data.error_auth != undefined) {
                            this.$swal.fire("Error", error.response.data.message, "error");
                            this.$store.dispatch("logOut").then(() => {
                                this.$router.push("/login");
                            });
                            return;
                        }
                        return this.$swal.fire("Request ", error.response.data.message, "error");
                    }
                }

                this.$sentry.captureException(error);
                this.$swal.fire("Error", error.message, "error");
            } finally {
                await this.$store.dispatch("setLoading", false);
            }
        },
    },
};
</script>

<style scoped>
input,
textarea {
    border-width: initial !important;
}

.container-overlay {
    position: relative;
}

.image-overlay {
    display: block;
    width: 100%;
    height: auto;
}

.overlay {
    position: absolute;
    top: 0;
    bottom: 10%;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
    background-color: #008CBA;
    cursor: pointer;
}

.container-overlay:hover .overlay {
    opacity: 1;
}

.text-overlay {
    color: white;
    font-size: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
}
</style>
